import { MaterialIcon } from "@website/icons/material";
import { isChannel } from "@website/utils/channel/helpers";

export const allServices = [
  {
    url: `/`,
    title: "هتل داخلی",
    icon: <MaterialIcon name="apartment" variant="outlined" />
  },
  {
    url: `/international-hotel`,
    title: "هتل خارجی",
    icon: <MaterialIcon name="location_city" variant="outlined" />
  },
  {
    url: `/flights`,
    title: "پرواز داخلی",
    icon: <MaterialIcon name="local_airport" variant="outlined" />
  },
  {
    url: `/inter-flights`,
    title: "پرواز خارجی",
    icon: <MaterialIcon name="flight_takeoff" />
  },
  {
    url: `/bus`,
    title: "اتوبوس",
    icon: <MaterialIcon name="directions_bus_filled" />
  },
  {
    url: `/villa`,
    title: "ویلا",
    icon: <MaterialIcon name="house" />
  },
  {
    url: `/tour`,
    title: "تورهای مسافرتی",
    icon: <MaterialIcon name="tour" />
  },
  ...(isChannel(["website"])
    ? [
        {
          url: `https://myvilla.snapptrip.com`,
          title: "پنل میزبان ویلا",
          icon: <MaterialIcon name="holiday_village" />,
          nofollow: true
        }
      ]
    : [])
];
